import SocketViewer from './SocketViewer';

export default SocketViewer;
